var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.895 5.684H34.106V18.947H1.895z",
    transform: "translate(-1088 -321) translate(420 305) translate(668 16)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#006CBA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.753.593H.918C.411.593 0 1.004 0 1.511v21.281c0 .508.41.919.918.919h33.835c.508 0 .919-.411.919-.919V1.512c0-.508-.41-.919-.919-.919zM2.762 7.58h3.807c.514.02.927.183 1.07.732l.828 3.982C7.653 10.21 5.693 8.477 2.73 7.76l.032-.181zm4.607 9.082l-2.2-7.513c1.581 1.012 2.928 2.617 3.402 3.734l.257.928 2.405-6.145h2.602L9.968 16.66l-2.6.002zm8.378.006h-2.455l1.535-9.011h2.457l-1.537 9.011zm4.273.136c-1.1-.012-2.16-.23-2.736-.482l.346-2.016.316.143c.807.337 1.33.473 2.313.473.705 0 1.461-.276 1.468-.88.004-.394-.316-.676-1.273-1.118-.932-.431-2.166-1.154-2.15-2.448.012-1.751 1.723-2.973 4.15-2.973.951 0 1.713.196 2.2.378l-.332 1.954-.222-.105c-.452-.181-1.033-.357-1.837-.344-.962 0-1.408.4-1.408.775-.005.421.52.7 1.38 1.117 1.416.643 2.071 1.423 2.062 2.448-.018 1.87-1.694 3.078-4.277 3.078zm10.643-.132s-.225-1.036-.3-1.35l-3.144-.004c-.096.243-.516 1.354-.516 1.354h-2.58l3.647-8.258c.259-.586.698-.748 1.286-.748h1.898l1.987 9.006h-2.278z",
    transform: "translate(-1088 -321) translate(420 305) translate(668 16)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.395 10.873l-.166-.777c-.125.339-.34.884-.326.86l-.978 2.519h2.039l-.57-2.602z",
    transform: "translate(-1088 -321) translate(420 305) translate(668 16)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/visa-card.e7bb20d0e052e7ecd98fa4dacdca2c72.svg";
export { ForwardRef as ReactComponent };